import styled from 'styled-components';
import { Input } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import { theme } from 'styles/theme';
import { Box, Text, Flex, Button } from 'atoms';

export const StoreName = styled(Box)`
	font-size: 10px;
	line-height: 14px;
	color: ${theme.colors.NightRider};
	text-transform: capitalize;
`;

export const InvoiceNumber = styled(Text)`
	margin-top: 0.3rem;
	font-weight: 300;
	font-size: 8px;
	color: ${theme.colors.NightRider};
	line-height: 11px;
	text-transform: uppercase;
`;

export const InputLabel = styled(Box)`
	position: absolute;
	top: 4px;
	left: 8px;
	z-index: 1;
	font-size: 8px;
	line-height: 10px;
	color: ${theme.colors.Jet};
`;

export const InputField = styled(Input)`
	width: 100%;
	height: 50px;
	padding: 13px 26px 5px 12px;
	border-radius: 4px;
	border: 1px solid ${theme.colors.Jet};
	font-size: 10px;
`;

export const ClearIcon = styled(CloseCircleOutlined)`
	position: absolute;
	right: 10px;
	top: 50%;
	font-size: 18px;
	transform: translateY(-50%);
`;

export const InputErrorMsg = styled(Box)`
	position: absolute;
	padding-top: 2px;
	font-size: 10px;
	line-height: 11px;
	color: ${theme.colors.ErrorMessage};
`;

export const SearchList = styled(Flex)`
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 10px 8px 10px 0;
	border-bottom: 1px solid ${theme.colors.LightBgGrey};
`;

export const GoBtn = styled(Button)`
	padding: 0 1rem;
	border-radius: 0;
	height: 25px;
	font-size: 12px;
`;
